import { useErrorWatcher } from "../utils/use-error-watcher";

export function ExternalErrorNote({ name }: { name: string | string[] }) {
  const { errors } = useErrorWatcher({ name });

  return <span className="text-[--ant-color-error]">{errors.join(" ")}</span>;
}
